import { render, staticRenderFns } from "./DerbyRaceRating.vue?vue&type=template&id=0d47fc68&scoped=true&"
import script from "./DerbyRaceRating.vue?vue&type=script&lang=js&"
export * from "./DerbyRaceRating.vue?vue&type=script&lang=js&"
import style0 from "./DerbyRaceRating.vue?vue&type=style&index=0&id=0d47fc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47fc68",
  null
  
)

export default component.exports